import type * as React from 'react';
import type { JSX } from 'react';

export function Logo(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" {...props}>
			<title>Eqity</title>
			<path d="m116 112.2 73.2 8.1c2-7.7 3-15.8 3-24.1 0-13.4-2.8-26.2-7.7-37.8l-84.3 41.2-4.2 28.3-85.7 11.7c3 6 6.6 11.5 10.8 16.7l83.8-17.7 11.1-26.4z" />
			<path d="m125.7 128.2-9.8 22.8h.1v1l-82.3 17.4c16.8 14.3 38.5 22.9 62.3 22.9 39.2 0 72.9-23.7 87.9-57.4l-58.2-6.7zm-43.3-14 3.8-25 91.1-44.5C160.2 17.8 130.2 0 96 0 42.9 0-.1 43-.1 96.1c0 10 1.5 19.7 4.4 28.8l78.1-10.7z" />
		</svg>
	);
}
